import { render, staticRenderFns } from "./PresetDelete.vue?vue&type=template&id=54f8b1f4&lang=pug&"
import script from "./PresetDelete.vue?vue&type=script&lang=ts&"
export * from "./PresetDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PresetDelete.vue"
export default component.exports